var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CoursesEnciteItem', {
    attrs: {
      "pageTitle": 'Online Courses CMMC Level 2',
      "courseTitle": 'CMMC Level 2',
      "courseItems": _vm.items,
      "informationCardColor": '#00AFF7',
      "informationCardTextColor": '#001426'
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }